import { accountApi } from '../../apiAxios/modules/account.api';
import Axios from 'axios';
import router from '../../app/router';

const pureAxios = Axios.create();
export default {
    namespaced: true,
    state: {
        token: '',
        username: '用户',
        userType: '1', // 1 普通用户 2 管理员 3 服务用户 9 超级管理员
        userInfo: {},
        globalConfigs: {}
    },
    mutations: {
        setToken (state, val) {
            if (!val) return;
            localStorage.setItem('token', val);
            state.token = val;
        },
        setUsername (state, val) {
            if (!val) return;
            localStorage.setItem('username', val);
            state.username = val;
        },
        // 缓存用户所有信息
        setUserInfo (state, val) {
            state.userInfo = val;
            state.userType = val.UserType;
            state.isSuperAdmin = (val.UserType + '') === '9';
        },
        retrieveInfo (state) {
            state.token = localStorage.getItem('token') || '';
            state.username = localStorage.getItem('username') || '用户';
        },
        // 登出
        async logout (state) {
            if (state.token) {
                await accountApi.ssoLogout();
            }
            window.localStorage.clear();
            await router.replace('/login');
        },
        setGlobalConfigs (state, config) {
            state.globalConfigs = config || {};
        }
    },
    actions: {
        // 获取全局配置
        async getGlobalConfigs (context) {
            try {
                const result = await pureAxios(`${process.env.NODE_ENV === 'production' ? __webpack_public_path__ : ''}config.json`);
                context.commit('setGlobalConfigs', result.data);
            } catch (err) {
                console.error(err);
            }
        },
        // 获取用户登录信息
        async getUserInfo (context) {
            if (location.hash.indexOf('transGpt') > -1) {
                return;
            }
            let res = await accountApi.getUserInfo();
            if (res && +res.data.OpCode === 0) {
                let userInfo = res.data.Data;
                await context.commit('setUserInfo', userInfo);
                await context.commit('setUsername', userInfo.UserName);
            } else {
                console.error('获取用户信息有误');
                context.commit('logout', context.state.token);
            }
        }
    }
};
